import { PATHS } from 'constants/pathsB2b';
import { IpadToTvMultiScreenEvent, TvToIpadMultiScreenEvent } from 'events/multiScreenEvent';
import {
  SCREEN_CHANGE_EVENT,
  WindowPlacementApiWindow,
} from 'shared-types/windowPlacementAPICustomTypes';

const getMultiscreenEvent = (tv: Window | null) => {
  return (event: IpadToTvMultiScreenEvent) => {
    tv?.document.dispatchEvent(new IpadToTvMultiScreenEvent(event.actionType, event.actionData));
  };
};

const getExternalEvent = (ipad: Window | null) => {
  return (event: TvToIpadMultiScreenEvent) => {
    ipad?.document.dispatchEvent(new TvToIpadMultiScreenEvent(event.actionType, event.actionData));
  };
};

const registerEvents = (ipad: Window, tv: Window) => {
  tv.document.addEventListener('externalscreenevent', getExternalEvent(ipad) as EventListener);
  ipad.document.addEventListener('multiscreenevent', getMultiscreenEvent(tv) as EventListener);
};

export const executeLauncherOption = async () => {
  const ipad: WindowPlacementApiWindow = window;
  const FULL_SCREEN_EXIT_DELAY_IN_MS = 2000;

  const TV_ID = 'tv';

  const openTv = () => {
    return window.open(
      `${window.location.origin}${PATHS.DESKTOP_PLAYER}`,
      TV_ID,
      `height=${window.screen.height}; width=${window.screen.width}; left=0; top=0`,
    );
  };

  const screenDetails = ipad?.getScreenDetails ? await ipad.getScreenDetails() : null;

  let tv = screenDetails?.screens && screenDetails?.screens.length > 1 ? openTv() : null;

  const registerEventsOnTvLoad = () => {
    tv?.addEventListener(
      'load',
      () => {
        return tv
          ? registerEvents(ipad, tv)
          : () => {
              console.log(
                new Error('We couldnt add an event listener on the tv object as it is null'),
              );
            };
      },
      true,
    );
  };

  registerEventsOnTvLoad();

  screenDetails?.addEventListener(SCREEN_CHANGE_EVENT, async () => {
    if (screenDetails.screens.length === 1) {
      tv?.close();
      ipad.removeEventListener('multiscreenevent', getMultiscreenEvent(tv) as EventListener);
      tv?.removeEventListener('externalscreenevent', getExternalEvent(ipad) as EventListener);
      return;
    }

    if (document.fullscreenElement !== null) {
      await document.exitFullscreen();
      document.dispatchEvent(new Event('leaveFullScreen'));
    }

    setTimeout(() => {
      tv = openTv();
      registerEventsOnTvLoad();
    }, FULL_SCREEN_EXIT_DELAY_IN_MS);
  });
};

export const executeDtvOption = () => {
  const ipad = window;
  const tv = window.open(`${window.location.origin}/player`);

  if (tv != null) {
    tv.addEventListener('load', () => registerEvents(ipad, tv), true);
  }
};
